import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Music4, Square } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { usePlayer } from "@/context/PlayerContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ON_KEY = "sk_ambient_on";

export const AmbientMusic = () => {
  const { t, fontClass } = useLang();
  const { current } = usePlayer();
  const audioRef = useRef(null);
  const [url, setUrl] = useState(null);
  const [on, setOn] = useState(false);

  useEffect(() => {
    const a = new Audio();
    a.loop = true;
    a.volume = 0.2;
    a.preload = "none";
    audioRef.current = a;
    return () => { a.pause(); a.src = ""; };
  }, []);

  useEffect(() => {
    axios.get(`${API}/ambient`).then((r) => setUrl(r.data?.url || null)).catch(() => {});
  }, []);

  const toggle = () => {
    const a = audioRef.current;
    if (!a || !url) return;
    if (on) {
      a.pause();
      setOn(false);
      localStorage.setItem(ON_KEY, "false");
    } else {
      if (a.src !== url) a.src = url;
      const p = a.play();
      if (p && p.catch) p.catch(() => {});
      setOn(true);
      localStorage.setItem(ON_KEY, "true");
    }
  };

  if (!url) return null;

  const bottom = current ? 96 : 20;

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="ambient-music-toggle"
      className={`${fontClass()} fixed left-4 z-40 inline-flex items-center gap-2 h-12 pl-4 pr-5 rounded-full font-bold text-sm shadow-lg transition-transform hover:scale-105 active:scale-95`}
      style={{
        bottom,
        background: on ? "var(--accent)" : "var(--card)",
        color: on ? "#fff" : "var(--text)",
        border: "1px solid var(--border)",
      }}
      aria-pressed={on}
    >
      {on ? <Square size={16} fill="#fff" /> : <Music4 size={18} style={{ color: "var(--accent)" }} />}
      <span>{on ? t("ambient_stop") : t("ambient_play")}</span>
    </button>
  );
};
